import React from 'react';

import {TableRow} from "../../../core/components/table/table-row";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {TableHeader} from "../../../core/components/table/table-header";
import {ScoreboardWidgetStageViewModel} from "../models/scoreboard-widget.stage-view-model";

export class ScoreboardWidgetHeadersRowProps extends BaseProps {
  stages: Array<ScoreboardWidgetStageViewModel>;
}

export const ScoreboardWidgetHeadersTableRow = (props: ScoreboardWidgetHeadersRowProps) => {
  return (
    <TableRow className={'scoreboard-widget-headers-table-row'}>
      <TableHeader className={'scoreboard-widget-headers-table-row-competitors'}/>
      {
        props.stages?.map((stage: ScoreboardWidgetStageViewModel) => {
          const className = ['scoreboard-widget-headers-table-row-stage',(stage.isLive ? 'scoreboard-widget-headers-table-row-stage-live' : '')].join(' ');

          return <TableHeader className={className} key={stage.id}>{stage.title}</TableHeader>})
      }
    </TableRow>
  )
}
